export enum OddsFormat {
  Decimal = 1,
  Fractional = 2,
  American = 3
}
